module.exports = __webpack_public_path__ + "static/media/dental-card.70ce5a18.svg";